<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 條件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
              <a-col :md="8" :sm="24">
                <a-form-item label="用戶暱稱" prop="userName">
                  <a-input v-model="queryParam.userName" placeholder="請輸入用戶暱稱" allow-clear/>
                </a-form-item>
              </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="審核狀態" prop="applicationStatus">
                <a-select v-model="queryParam.applicationStatus">
                  <a-select-option :value="0">
                    待審核
                  </a-select-option>
                  <a-select-option :value="1">
                    已付款
                  </a-select-option>
                  <a-select-option :value="2">
                    已拒絕
                  </a-select-option>
                  <a-select-option :value="3">
                    待付款
                  </a-select-option>
                  <a-select-option :value="4">
                    待付款
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="店鋪名稱" prop="storeName">
                  <a-input v-model="queryParam.storeName" placeholder="請輸入店鋪名稱" allow-clear/>
                </a-form-item>
              </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查詢</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />

      <!-- 增加修改 -->
      <star-level
        ref="starLevel"
        @ok="getList"
      />

      <!-- 增加修改 -->
      <detail-form
        ref="detailForm"
        @ok="getList"
      />


      <!-- 數據展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered">

        <img style="width: 48px;height: 48px;" preview="店鋪LOGO" :src="record.storeLogo" v-if="record.storeLogo != null && record.storeLogo != ''" slot="storeLogo" slot-scope="text, record">

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.applicationStatus == 0">
            審核
          </a>
          <a-divider type="vertical"/>
          <a @click="$refs.starLevel.handleUpdate(record, undefined)">
            設置星級
          </a>
           <a-divider type="vertical"/>
          <a @click="$refs.detailForm.handleUpdate(record, undefined)">
            詳情
          </a>
        </span>
      </a-table>
      <!-- 分頁 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 條`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageStoreCertification, delStoreCertification } from '@/api/platform/storeCertification'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import StarLevel from './modules/StarLevel'
import DetailForm from './modules/DetailForm'

export default {
  name: 'StoreCertification',
  components: {
    CreateForm,
    StarLevel,
    DetailForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高級搜索 展開/關閉
      advanced: false,
      // 非單個禁用
      single: true,
      // 非多個禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查詢參數
      queryParam: {
        merchantType: null,
        certificationType: null,
        legalRealName: null,
        legalMobile: null,
        legalCard: null,
        portraitPlane: null,
        emblemPlane: null,
        businessLicense: null,
        companyName: null,
        socialCredit: null,
        businessScope: null,
        userId: null,
        applicationStatus: null,
        refusalCause: null,
        storeName: null,
        storeLogo: null,
        storeBackground: null,
        typeId: null,
        classId: null,
        integralBail: null,
        integralServe: null,
        storeCountry: null,
        storeProvinceName: null,
        storeCityName: null,
        storeCountyName: null,
        storeDetailedAddress: null,
        storeLongitude: null,
        storeDimensionality: null,
        companyCountry: null,
        companyProvinceName: null,
        companyCityName: null,
        companyCountyName: null,
        companyDetailedAddress: null,
        companyLongitude: null,
        companyDimensionality: null,
        companyAddress: null,
        storeDetail: null,
        openStartTime: null,
        openEndTime: null,
        storeCall: null,
        storePrincipal: null,
        principalCall: null,
        doorPicture: null,
        starLevel: null,
        collectionNum: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '店鋪名稱',
          dataIndex: 'storeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '店鋪logo',
          dataIndex: 'storeLogo',
          ellipsis: true,
          align: 'center',
          scopedSlots: {customRender: "storeLogo"}
        },
        {
          title: '商家類型',
          dataIndex: 'merchantType',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
            if (value == 1) {
              return "線上"
            }
            if (value == 2) {
              return "線下"
            }
          }
        },
        {
          title: '認證類型',
          dataIndex: 'certificationType',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
            if (value == 1) {
              return "公司"
            }
            if (value == 2) {
              return "個體"
            }
          }
        },
        {
          title: '用戶編號',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '店鋪行業',
          dataIndex: 'typeName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '套餐名稱',
          dataIndex: 'className',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '保證金',
          dataIndex: 'integralBail',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '服務費',
          dataIndex: 'integralServe',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '星級',
          dataIndex: 'starLevel',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
            if (value == 1) {
              return "一星"
            }
            if (value == 2) {
              return "二星"
            }
            if (value == 3) {
              return "三星"
            }
            if (value == 4) {
              return "四星"
            }
            if (value == 5) {
              return "五星"
            }
          }
        },
        {
          title: '申請狀態',
          dataIndex: 'applicationStatus',
          ellipsis: true,
          align: 'center',
          customRender: function (value, record) {
            if (value == 0) {
              return "審核中"
            }
            if (value == 1) {
              return "已付款"
            }
            if (value == 2) {
              return "已拒絕"
            }
            if (value == 3) {
              return "已過期"
            }
            if (value == 4) {
              return "待付款"
            }
          }
        },
        {
          title: '拒絕原因',
          dataIndex: 'refusalCause',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查詢店鋪-商家認證列表 */
    getList () {
      this.loading = true
     pageStoreCertification(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按鈕操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按鈕操作 */
    resetQuery () {
      this.queryParam = {
        merchantType: undefined,
        certificationType: undefined,
        legalRealName: undefined,
        legalMobile: undefined,
        legalCard: undefined,
        portraitPlane: undefined,
        emblemPlane: undefined,
        businessLicense: undefined,
        companyName: undefined,
        socialCredit: undefined,
        businessScope: undefined,
        userId: undefined,
        applicationStatus: undefined,
        refusalCause: undefined,
        storeName: undefined,
        storeLogo: undefined,
        storeBackground: undefined,
        typeId: undefined,
        classId: undefined,
        integralBail: undefined,
        integralServe: undefined,
        storeCountry: undefined,
        storeProvinceName: undefined,
        storeCityName: undefined,
        storeCountyName: undefined,
        storeDetailedAddress: undefined,
        storeLongitude: undefined,
        storeDimensionality: undefined,
        companyCountry: undefined,
        companyProvinceName: undefined,
        companyCityName: undefined,
        companyCountyName: undefined,
        companyDetailedAddress: undefined,
        companyLongitude: undefined,
        companyDimensionality: undefined,
        companyAddress: undefined,
        storeDetail: undefined,
        openStartTime: undefined,
        openEndTime: undefined,
        storeCall: undefined,
        storePrincipal: undefined,
        principalCall: undefined,
        doorPicture: undefined,
        starLevel: undefined,
        collectionNum: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 刪除按鈕操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '確認刪除所選中數據?',
        content: '當前選中編號為' + ids + '的數據',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delStoreCertification(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '刪除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空刪除ids列表
          that.ids = []
        }
      })
    },
    /** 導出按鈕操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否確認導出?',
        content: '此操作將導出當前條件下所有數據而非選中數據',
        onOk () {
          that.download('platform/store-certification/export', {
            ...that.queryParam
          }, `店鋪-商家認證_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
